import { MARKETING_API_BASE } from "@/config/apiConfig";

export interface EmployeeReferralPayload {
  userName: string;
  userEmail: string;
  hrEmail?: string;
}

export interface HrDetailsPayload {
  name: string;
  email: string;
  companyName: string;
  phoneNumber?: string;
  message?: string;
}

/**
 * Saves a corporate carpool employee referral (name, email, optional HR email).
 */
export async function submitEmployeeReferral(
  payload: EmployeeReferralPayload
): Promise<void> {
  const body: EmployeeReferralPayload = {
    userName: payload.userName,
    userEmail: payload.userEmail,
  };

  // The API validates hrEmail as an email even when blank, so only include it
  // when the user actually provided one.
  if (payload.hrEmail && payload.hrEmail.trim()) {
    body.hrEmail = payload.hrEmail.trim();
  }

  const res = await fetch(`${MARKETING_API_BASE}/marketing/employee`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "*/*",
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error(`Employee referral request failed: ${res.status}`);
  }
}

/**
 * HR / company enquiry for the Corporate Carpool program page.
 */
export async function submitHrDetails(payload: HrDetailsPayload): Promise<void> {
  const body: Record<string, string> = {
    name: payload.name.trim(),
    email: payload.email.trim(),
    companyName: payload.companyName.trim(),
  };

  if (payload.phoneNumber?.trim()) {
    body.phoneNumber = payload.phoneNumber.trim();
  }
  if (payload.message?.trim()) {
    body.message = payload.message.trim();
  }

  const res = await fetch(`${MARKETING_API_BASE}/marketing/hr-details`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "*/*",
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error(`HR enquiry request failed: ${res.status}`);
  }
}
